import React from 'react';

export const VehicleDetailsModal = ({ vehicle, onClose }) => {
  if (!vehicle) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="glass-card p-6 rounded-xl shadow-lg w-full max-w-md animate-fadeIn custom-scrollbar" style={{maxHeight: '90vh', overflowY: 'auto'}}>
        <h3 className="text-2xl font-bold gradient-text mb-4 text-center">Vehicle Details</h3>
        <div className="space-y-3 text-gray-300">
          <p><strong>Plate:</strong> {vehicle.plate || 'N/A'}</p>
          <p><strong>Model:</strong> {vehicle.model_name || 'N/A'}</p>
          <p><strong>Owner Identifier:</strong> <span className="font-mono text-sm break-all">{vehicle.owner_identifier || 'N/A'}</span></p>
          <p><strong>Fuel:</strong> {vehicle.fuel !== undefined ? `${vehicle.fuel.toFixed(1)}%` : 'N/A'}</p>
          <p><strong>Body Damage:</strong> {vehicle.body !== undefined ? `${vehicle.body.toFixed(1)}%` : 'N/A'}</p>
          <p><strong>Garage:</strong> {vehicle.garage || 'N/A'}</p>
          <p><strong>Status:</strong> {vehicle.state || 'N/A'}</p>
          {vehicle.stored_location && (
            <p><strong>Stored Location:</strong> X: {vehicle.stored_location.x?.toFixed(2) || 'N/A'}, Y: {vehicle.stored_location.y?.toFixed(2) || 'N/A'}, Z: {vehicle.stored_location.z?.toFixed(2) || 'N/A'}</p>
          )}
        </div>
        <button
          onClick={onClose}
          className="mt-6 bg-[#316dae] hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300 w-full"
        >
          Close
        </button>
      </div>
    </div>
  );
};